export const createDescribedById = (id: string) => {
  return `${id}-help`;
};
